var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"dz-label"},[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('ckeditor',_vm._g({attrs:{"value":_vm.value,"config":_vm.editorConfig}},_vm.$listeners))],1)}
var staticRenderFns = []

export { render, staticRenderFns }